import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { URLSearchParamsConstructor } from "../../helpers/UrlSearchParamConstructor";
import { sec } from "../../security";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;
// const apiServerUrl = "http://localhost:3002/";

export const apiLitigationSlice = createApi({
  reducerPath: "litigation",
  tagTypes: ["getLitigationByEmployerId", "getLitigationByAttorneyId"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),

  endpoints: (builder) => ({
    getLitigationByEmployerId: builder.query({
      query: (args) => {
        const params = URLSearchParamsConstructor(args);
        return {
          url: "/api/v1/deals/employers_list",
          method: "get",
          params
        };
      },
      providesTags: ["getLitigationByEmployerId"]
    }),
    getLitigationByAttorneyId: builder.query({
      query: (args) => {
        const params = URLSearchParamsConstructor(args);
        return {
          url: "/api/v1/dockets/attorney_list",
          method: "get",
          params
        };
      },
      providesTags: ["getLitigationByAttorneyId"]
    })
  })
});

export const {
  useGetLitigationByAttorneyIdQuery,
  useGetLitigationByEmployerIdQuery
} = apiLitigationSlice;
